import React from 'react';
import {connect} from "react-redux";
import AuthService from "../../../../../../services/AuthService";
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import ArrowUpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import ArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import {
    getPointsAmelioration,
    setPointsAmelioration
}from './../../../../../../actions/entreprise/actions_entreprise_entretien';
import AutoComplete from "material-ui/AutoComplete/index";

class PointsAmeliorationTable extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            t1Open:false,
            t1AutoComplete:[],
            searchText:''
        };
        this.Auth = new AuthService();
        this.fetchPointsAmelioration = this.fetchPointsAmelioration.bind(this);
        this.persistPointsAmelioration = this.persistPointsAmelioration.bind(this);
        this.deletePointAmelioration = this.deletePointAmelioration.bind(this);
        this.handleNewPointAmelioration = this.handleNewPointAmelioration.bind(this);
    }

    persistPointsAmelioration(){
        const activites = this.props.activites_principales;
        this.Auth.fetch('/salarie/points_amelioration',{
            method:'PUT',
            data:activites
        });
    }

    handleNewPointAmelioration(x){
        const eh = this.props.entretienHeader;
        this.Auth.fetch('/salarie/points_amelioration',{
            method:'POST',
            data:{
                id_salarie: eh.id_salarie,
                id_entretien: eh.id,
                id_entreprise: eh.id_entreprise,
                point_amelioration:x,
                id_echeance:1
            }
        }).then( x=>{
            this.fetchPointsAmelioration();
            this.setState({t1Open:true, searchText:''});
        });
    }

    fetchPointsAmelioration(){
        const id_entretien = this.props.entretienHeader.id;
        this.props.dispatch(getPointsAmelioration(id_entretien));
    }

    deletePointAmelioration(id){
        this.Auth.fetch(`/salarie/points_amelioration/${id}`,{
            method:'delete'
        }).then(x=>this.fetchPointsAmelioration());
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.entretienHeader !== this.props.entretienHeader )
            this.fetchPointsAmelioration();
    }
    componentDidMount(){
        if(this.props.entretienHeader && this.props.entretienHeader.id){
            this.fetchPointsAmelioration();
        }
        this.Auth.fetch('/societe/points_amelioration')
            .then(x=> this.setState({t1AutoComplete:x.data.payload}))
    }



    render() {
        return (
            <div>
                <AutoComplete
                    hintText="Points d'amélioration dans le poste actuel du salarié"
                    floatingLabelText="Points d'amélioration"
                    filter={AutoComplete.caseInsensitiveFilter}
                    dataSource={this.state.t1AutoComplete}
                    searchText={this.state.searchText}
                    onUpdateInput={(text)=>this.setState({searchText:text})}
                    onNewRequest={(x)=>this.handleNewPointAmelioration(x)}
                    fullWidth={true}
                    maxSearchResults={5}
                />
                <table className="table table-sm table-hover">
                    <thead className="thead-light" style={{cursor:'pointer'}} onClick={()=>this.setState({t1Open:!this.state.t1Open})}>
                    <tr>
                        <th scope="col">Points d'amélioration </th>
                        <th width="200" scope="col">échéance</th>
                        <th width="35" style={{textAlign:'right'}} scope="col">{this.state.t1Open ? <ArrowUpIcon/> : <ArrowDownIcon/>}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.t1Open && this.props.points_amelioration.map(x=>{
                        return (
                            <tr key={x.id}>
                                <td>{x.point_amelioration}</td>
                                <td>
                                    <SelectField
                                        value={x.id_echeance}
                                        fullWidth={true}
                                        floatingLabelText="Échéance"
                                        onChange={(a, b, c)=>{
                                            this.props.dispatch(
                                                setPointsAmelioration(
                                                  this.props.points_amelioration.map(x2 =>{
                                                      if(x.id === x2.id){
                                                          return {
                                                              ...x2, id_echeance: c
                                                          }
                                                      }else{
                                                          return x2;
                                                      }
                                                  })
                                                )
                                            );
                                        }}
                                        maxHeight={400}
                                    >
                                        {this.props.params_echeances.map(x => <MenuItem key={x.id} value={x.id} primaryText={x.echeance}/>)}
                                    </SelectField>
                                </td>
                                <td style={{textAlign:'right'}}>
                                    <DeleteIcon style={{cursor:'pointer'}} onClick={()=>this.deletePointAmelioration(x.id)} color='red' />
                                </td>
                            </tr>);
                    })}
                    </tbody>
                </table>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        entretienHeader: store.entretien.header,
        points_amelioration: store.entretien.points_amelioration,
        params_echeances: store.params.echeances,
    }
}

export default connect(mapStateToProps)(PointsAmeliorationTable);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/comps/PointsAmeliorationTable.js